const comparisonSwiper = new Swiper('.comparison_slider', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: {
        enabled: true,
        momentum: true,
    },
    grabCursor: true,
    navigation: {
        nextEl: '.comparison_slider .swiper-button-next',
        prevEl: '.comparison_slider .swiper-button-prev',
    },
});